/* Menu functions */
(function( ) {
    'use strict'

    /* Toggle scrolled state */
    if ( document.querySelector('.menu-button-container') != null ) {
        document.querySelector('.menu-button-container').addEventListener( 'click', ( e ) => {
            /* Setup */
            e.preventDefault()
            let clickedElem = e.target.closest('.menu-button-container')
            
            /* Toggle */
            document.querySelector( 'body' ).classList.toggle( 'is-open-menu' )

            /* Check for active / inactive */
            if ( clickedElem.classList.contains( 'open' ) ) {
                /* State is active */
                clickedElem.classList.add( 'closing' )
                clickedElem.classList.remove( 'open' )
                document.querySelector( 'body' ).classList.remove( 'navigation-open' )
 
                /* Remove active after turning */
                setTimeout( () => { 
                    clickedElem.classList.remove( 'closing' )
                }, 200 )
            } else {
                /* State is inactive */
                clickedElem.classList.add( 'opening' )

                /* Remove active after turning */
                setTimeout( () => { 
                    clickedElem.classList.remove( 'opening' )
                    clickedElem.classList.add( 'open' )
                }, 200 )

                /* Remove */
                document.querySelector( 'body' ).classList.add( 'navigation-open' )
            }

            /* Return */
            return false
        })
    }
})( )
